import {OrderListColumns} from "../../components/list/models/OrderListColumns";

export default [
    "account",
    "side",
    "quantity",
    "remaining",
    "code",
    "exchange",
    "expiry",
    "strike",
    "price-instruction",
    "delta",
    "vol",

    "limit",
    "theo",

    "lifetime",

    "market",
    "created",
    "status",
    "updated",

    "action-cancel",
    "action-amend",
    "info"
] as OrderListColumns;
